import {
  CARD,
  IMAGE_MAP,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  POPUP,
  PopupDefinition,
  TEXT,
  AUDIO_POPUP,
  AudioPopupDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Interactive4: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  let maxWidth = 1200;
  let maxHeight = 800;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'ImageMap':
        if (
          item.pictures &&
          item.pictures.length &&
          item.pictures?.[0]?.mediaUrl
        ) {
          maxWidth = item.pictures?.[0]?.width as number;
          maxHeight = item.pictures?.[0]?.height as number;
        }

        columns.items.push({
          id: 'LAYOUT_LIST',
          type: LAYOUT_LIST,
          values: { align: 'center' },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'lg',
                height: '425px',
                width: '400px',
                padding: '0px'
              },
              items: [
                {
                  type: IMAGE_MAP,
                  id: item.id,
                  values: {
                    imageUrl: item.pictures?.[0]?.mediaUrl,
                    w: '400px',
                    h: '420px'
                  },
                  items: (item.items || []).map((i, index) => {
                    const parts = (i.coordinates || '').split(',');

                    if (i.audios) {
                      return {
                        type: AUDIO_POPUP,
                        id: `${item.id}-${index}`,
                        items: [],
                        values: {
                          title: item.variant == 'number' ? index + 1 : null,
                          left:
                            parts[0] && (parseInt(parts[0]) * 100) / maxWidth,
                          top:
                            parts[1] && (parseInt(parts[1]) * 100) / maxHeight,
                          name: i.title,
                          body: i.body,
                          mediaUrl: i.audios?.[0]?.mediaUrl,
                          subtitlesUrl: i.audios?.[0]?.subtitlesUrl,
                          blocking: true,
                          replay: true
                        }
                      } as AudioPopupDefinition;
                    } else {
                      return {
                        type: POPUP,
                        id: `${item.id}-${index}`,
                        values: {
                          btnTitle: item.variant == 'number' ? index + 1 : '+',
                          left: parts[0] && parseInt(parts[0]),
                          top: parts[1] && parseInt(parts[1]),
                          title: i.title,
                          subtitle: i.subtitle,
                          body: i.body,
                          blocking: true
                        }
                      } as PopupDefinition;
                    }
                  })
                }
              ]
            }
          ]
        });
        break;
      case 'Text':
      case 'Question':
        columns.items.push({
          id: 'LAYOUT_LIST_RIGHT',
          type: LAYOUT_LIST,
          values: { align: 'left' },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading2'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
